module.exports = __webpack_public_path__ + "components/blog.tpl.php";


//////////////////
// WEBPACK FOOTER
// ./src/components/blog/blog.tpl.php
// module id = 474
// module chunks = 0 1